import angular from 'angular';
import ngResource from 'angular-resource';
import config from '../../config/config';

import myBookingService from './mybooking.service';

const myBookingModule = angular.module('mybooking', [
    ngResource,
    config
])
    .service('myBookingService', myBookingService)
    .name;

export default myBookingModule;


// WEBPACK FOOTER //
// ./client/app/api/mybooking/mybooking.js